define(["dojo/query","/var/jenkins_home/workspace/c8_release_C8-7.10/Projects/WebAccess/node_modules/dojo-webpack-plugin/loaders/dojo/runner.js",""], function(loader, runner) {
   return runner(loader, "css2", __webpack_require__.dj.c(), false);
});